module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cardlist"
  }, _vm._l((_vm.list), function(item) {
    return _c('AddNewModuleCard', _vm._b({
      key: item.id,
      attrs: {
        "readonly": _vm.readonly
      },
      on: {
        "removeEmitId": _vm.removeEmitId
      }
    }, 'AddNewModuleCard', item, false))
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16541802","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newprogram/components/cardlist/CardList.vue
// module id = 15f91e4eaed60f1124a7
// module chunks = 10